import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ApiService } from 'app/services/api.service';
import { CallListItem } from 'app/models/call-list-item';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-phonebook-dialog',
    templateUrl: './phonebook-dialog.component.html',
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./phonebook-dialog.component.css']
})
export class PhonebookDialogComponent implements OnInit {

  callList: CallListItem[] = [];
  grouped: Record<string, CallListItem[]> = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    const customerId = this.data.customerId.substring(8);
    const serverId = this.data.serverId.substring(0, 8);
    this.api.getCustomerCallList(customerId, serverId).subscribe({
      next: (res) => {
        this.callList = res;
        this.grouped = this.getGrouped();
      },
      error: (err) => {
        console.error("Failed to load phonebook", err);
      }
    });
  }

  getGrouped() {
    const groups: any = {};

    this.callList.forEach(item => {
      const key = `${item.area} (${item.callWindowStart.slice(0,5)}-${item.callWindowEnd.slice(0,5)})`;

      if (!groups[key]) {
        groups[key] = [];
      }

      groups[key].push(item);
    });

    return groups;
  }
}